/**
 * Renders a trash control for table rows; uses a direct click handler so delete
 * still works when the table sets disableHoverAndClick (row-level clicks are skipped).
 */

import React from "react";
import { Delete } from "../../../../svg/delete";

interface DeleteIconCellProps {
  /** Full row payload passed through from CustomTable (includes id). */
  rowData: Record<string, unknown> | undefined;
  /** Parent callback from CustomTable props.onDeleteIconClick. */
  onDelete?: (rowData: unknown) => void;
}

/**
 * Delete icon cell: stops event propagation and invokes onDelete with row data.
 *
 * @param rowData - Row object from the table.
 * @param onDelete - Optional handler wired from CustomTable.
 */
export const DeleteIconCell: React.FC<DeleteIconCellProps> = ({
  rowData,
  onDelete,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (rowData != null && onDelete) {
      onDelete(rowData);
    }
  };

  return (
    <button
      type="button"
      className="flex cursor-pointer items-center justify-center rounded p-1 hover:bg-primaryGray-16"
      aria-label="Delete row"
      onClick={handleClick}
    >
      <Delete width={20} height={20} />
    </button>
  );
};

export default DeleteIconCell;
